import { useEffect, useState } from "react";
import "../css/WeblogSection.css";
import Article from "./Article";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../apiClient";
import colors from '../colors';


function WeblogSection()
{
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    const navigate = useNavigate();
    const [fetchedArticles,setFetchedArticles]=useState([]);
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
    

    //get all articles from database:
    useEffect(() => {
        async function getAllArticles() {
    
          
            await apiClient.get(process.env.REACT_APP_BACK+"/articles/weblogArticles/"+4, config)
            .then((result) => {
            if (result.status == 200) {
              setFetchedArticles(result.data);
              
              return result.data;
            }
          })
          .catch((error) => {
            console.log(error);
            
          });
          
    
        }
        getAllArticles();
      },[]);

    return(
        <div id="weblog-section">

        <h2 style={{marginBottom:"0px"}}>مقاله های وبلاگ</h2>
        <p style={{marginBottom:"50px"}}>با آخرین اخبار و نکات دنیای تولید محتوا آشنا شوید</p>
    
            <div style={{display: desktop ?'flex' : "block",gap:'30px'}}>
                {fetchedArticles?.map((article, index) => (
                <div key={index} style={{ width: desktop? '50%' : '100%', display: 'flex', gap: '30px' }}>
                    <Article
                    article={article}
                    singleArticle={false}
                    />
                </div>
                ))}

            </div>


            <button 
            style={{marginTop:"50px"}} 
            className="login-button"
            onClick={()=>navigate("/weblog")}
            >
            مشاهده همه مقاله ها</button>


        </div>
    );
}
export default WeblogSection;